<h2>{{ 'selectDS' | translate }}</h2>
<mat-form-field>
  <mat-label>{{ 'server' | translate }}</mat-label>
  <mat-select formControlName="server" (selectionChange)="onServerSelected($event)">
    <mat-option *ngFor="let server of servers | keyvalue" [value]="server">
      {{ server.key }} ({{ server.value }})
    </mat-option>
  </mat-select>
</mat-form-field>